import React, { useState } from "react";

const PricingScale = () => {
  const [selectedClients, setSelectedClients] = useState("");
  const [customAmount, setCustomAmount] = useState("");
  const [totalCost, setTotalCost] = useState(0);

  const handleSelectChange = (event) => {
    const value = event.target.value;
    setSelectedClients(value);
    setCustomAmount("");
    calculateCost(value);
  };

  const handleCustomAmountChange = (event) => {
    const value = event.target.value;
    setCustomAmount(value);
    setSelectedClients("");
    calculateCost(value);
  };

  const calculateCost = (clients) => {
    const cost = (parseInt(clients) / 100) * 25 || 0;
    setTotalCost(cost);
  };

  return (
    <div className="pricing-scale-container">
      <div className="scale-header">
        <div className="badge">Best Value</div>
        <h2>Scale your Credit Repair Business</h2>
        <p className="mt-3">
          Use all of our tools and features to give your clients the best
          results and experience.
        </p>
      </div>

      <div className="scale-selection">
        <label htmlFor="client-select">Select Amount of Clients:</label>
        <select
          id="client-select"
          value={selectedClients}
          onChange={handleSelectChange}
        >
          <option value="">Select...</option>
          <option value="500">500</option>
          <option value="1000">1000</option>
          <option value="2000">2000</option>
        </select>
        <p>$25/month per 100 additional clients</p>
        <input
          type="number"
          placeholder="Enter Amount"
          value={customAmount}
          onChange={handleCustomAmountChange}
          min="0"
        />
      </div>

      <button className="pay-now-button">
        Pay Now (${totalCost.toFixed(2)})
      </button>

      <ul className="features-list">
        <li>Repair Clients Credit using AI (One-Click)</li>
        <li>Boost & Increase Clients Credit Score</li>
        <li>Monitor Clients Credit Score Performance</li>
        <li>Direct Message & Chat with Clients</li>
        <li>Clients Access Funding Portal</li>
        <li>Clients Access Invest Portal</li>
        <li>Clients Access Real Estate Guide</li>
        <li>Clients Access Business Acquisition Guide</li>
        <li>And More</li>
      </ul>
    </div>
  );
};

export default PricingScale;
